<style lang="scss">
@import "resources/sass/v1/abstracts/_variables";
@import "resources/sass/v1/abstracts/_mixins";

.image-text-block {
    position: relative;

    h2 {
        span {
            @include underline;
        }
    }

    .content-wrapper {
        p {
            font-weight: $font-weight-light;

            @media screen and (min-width: $screen-lg) {
                font-size: 20px;
                letter-spacing: 0.25px;
                line-height: 1.5;
            }
        }
    }

    .plyr {
        width: 100%;
    }

    .image-overlay {
        position: relative;
        margin: 0;

        &.with-bubble {
            @media screen and (min-width: $screen-sm) {
                width: 95%;
            }
        }

        img {
            width: 100%;
            height: auto;
        }

        .image-background {
            position: absolute;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;

            transform-origin: center;
            transform: scale(1.001);
        }

        .image-clip {
            position: relative;
            z-index: 1;
            transform-origin: center;

            transform: scale(1.007);

            @media screen and (min-width: $screen-lg) {
                transform: scale(1.005);
            }
        }

        .bubble {
            display: none;
        }

        .logo {
            display: block;
            position: absolute;
            height: auto;
            z-index: 2;

            width: 160px;
            height: 160px;
            top: -58px;
            right: 0;

            img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 3;
                width: 55%;
                height: 55%;
                object-fit: contain;
                object-position: center;
                font-family: "object-fit: contain;";
            }

            &:after {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                content: "";
                background-image: url("/svg/shapes/logo-background.svg");
                background-position: center;
                background-size: contain;
                background-repeat: no-repeat;
                width: 100%;
                height: 100%;
            }

            @media screen and (min-width: $screen-md) {
                width: 160px;
                height: 160px;
                top: -80px;
                right: unset;
                left: -32px;
            }

            @media screen and (min-width: $screen-lg) {
                top: -62px;
                left: 0;
                width: 210px;
                height: 210px;
            }

            @media screen and (min-width: $screen-xl) {
                top: -80px;
                left: -80px;
                width: 320px;
                height: 320px;
            }
        }

        &.with-bubble {
            .bubble {
                display: block;
                position: absolute;
                max-width: 49%;
                height: auto;
                z-index: 2;
                transition: opacity 0.5s cubic-bezier(0.5, -0.525, 0.475, 1.54),
                transform 0.7s cubic-bezier(0.5, -0.525, 0.475, 1.54);
                opacity: 0;
                transform: scale(0);

                &.visible {
                    opacity: 1;
                    transform: scale(1);
                }
            }

            &.bubble-top {
                @media screen and (min-width: $screen-sm) {
                    margin-top: 5%;
                }

                .bubble {
                    top: -5%;

                    @media screen and (max-width: $screen-xs-end) {
                        top: -15px;
                    }
                }
            }

            &.bubble-bottom {
                @media screen and (min-width: $screen-sm) {
                    margin-bottom: 5%;
                }

                .bubble {
                    bottom: -5%;

                    @media screen and (max-width: $screen-xs-end) {
                        bottom: -15px;
                    }
                }
            }

            &.bubble-right {
                @media screen and (min-width: $screen-sm) {
                    margin-right: 5%;
                }

                .bubble {
                    right: -5%;

                    @media screen and (max-width: $screen-xs-end) {
                        right: -15px;
                    }
                }
            }

            &.bubble-left {
                @media screen and (min-width: $screen-sm) {
                    margin-left: 5%;
                }

                .bubble {
                    left: -5%;

                    @media screen and (max-width: $screen-xs-end) {
                        left: -15px;
                    }
                }
            }
        }
    }

    .small {
        .image-overlay {
            max-width: 460px;
        }
    }
}

.cssmask .image-text-block.mask {
    @media screen and (min-width: $screen-xl) {
        margin-top: -212px;
        z-index: 2;

        .image-clip {
            visibility: hidden;
        }

        .image-background {
            z-index: 3;
            mask-size: cover;
            mask-image: url("/svg/shapes/shape-1-inverse.svg");
        }
    }
}

/**
 * No transition when resizing browser window
 */

body.resizing {
    .image-text-block {
        .bubble {
            transition: none !important;
        }
    }
}
</style>

<template>
    <div
        class="row image-text-block mb-80 mb-md-160"
        :class="{'mask': (mask == true || mask == 1)}"
        :id="slug(title)"
    >
        <div
            class="col-12 col-md-7 col-lg-6 mb-80 mb-md-0 d-flex flex-column align-items-start justify-content-center"
            :class="{'order-md-12': (orientation == 'right')}"
        >
            <div class="content-wrapper mw-100 mb-child-0 pl-md-16 pl-lg-32 pl-xl-80 pr-xl-80">
                <h2 v-html="underlinedTitle"></h2>

                <p
                    v-if="description"
                    class="mb-0"
                    v-html="description"
                >
                </p>

                <div class="mb-child-0">
                    <slot></slot>
                </div>
                <a
                    v-if="link && linkText"
                    :href="link"
                    class="btn btn-secondary mt-32 btn-special btn-lg"
                    :target="newTab ? '_blank' : false"
                >
                    <span v-html="linkText"></span>
                </a>
            </div>
        </div>
        <div
            v-if="image || (video != null && video != '')"
            class="col-12 col-md-5 col-lg-6 d-flex flex-column align-items-start justify-content-center flex-stretch-0"
            :class="{'order-md-1': (orientation == 'right'), 'small': !large}"
        >
            <template v-if="video != null && video != ''">
                <div
                    class="plyr__video-embed"
                    id="player"
                    ref="player"
                >
                    <iframe
                        :src="`https://www.youtube.com/embed/${video}?origin=${origin}&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`"
                        allowfullscreen
                        allowtransparency
                        allow="autoplay"
                    ></iframe>
                </div>
            </template>
            <template v-else>
                <div v-if="type"
                     class="image-overlay w-100 flex-stretch-0 flex-shrink-0"
                     :class="bubbleposition">
                    <div class="image-background lazyload w-100 h-100"
                        :data-bg="image"></div>
                    <template  v-if="linkText && link">
                        <a :href="link">
                            <img
                                v-if="type == 1"
                                class="image-clip img-fluid"
                                src="/svg/shapes/shape-1.svg"
                                alt="cirkel vorm"
                            >
                            <img
                                v-if="type == 2"
                                class="image-clip img-fluid"
                                src="/svg/shapes/shape-2.svg"
                                alt="cirkel vorm"
                            >
                            <img
                                v-if="type == 3"
                                class="image-clip img-fluid"
                                src="/svg/shapes/shape-3.svg"
                                alt="cirkel vorm"
                            >
                            <img
                                v-if="type == 10"
                                class="image-clip img-fluid"
                                src="/svg/shapes/shape-1-lightblue.svg"
                                alt="cirkel vorm"
                            >
                            <img
                                v-if="type == 20"
                                class="image-clip img-fluid"
                                src="/svg/shapes/shape-2-lightblue.svg"
                                alt="cirkel vorm"
                            >
                            <img
                                v-if="type == 30"
                                class="image-clip img-fluid"
                                src="/svg/shapes/shape-3-lightblue.svg"
                                alt="cirkel vorm"
                            >
                            <img
                                class="bubble"
                                :class="{'visible' : wasSeen}"
                                src="/svg/shapes/bubble-secondary.svg"
                                alt="bubbel vorm"
                            >
                        </a>
                    </template>
                    <template v-else>
                        <img
                            v-if="type == 1"
                            class="image-clip img-fluid"
                            src="/svg/shapes/shape-1.svg"
                            alt="cirkel vorm"
                        >
                        <img
                            v-if="type == 2"
                            class="image-clip img-fluid"
                            src="/svg/shapes/shape-2.svg"
                            alt="cirkel vorm"
                        >
                        <img
                            v-if="type == 3"
                            class="image-clip img-fluid"
                            src="/svg/shapes/shape-3.svg"
                            alt="cirkel vorm"
                        >
                        <img
                            v-if="type == 10"
                            class="image-clip img-fluid"
                            src="/svg/shapes/shape-1-lightblue.svg"
                            alt="cirkel vorm"
                        >
                        <img
                            v-if="type == 20"
                            class="image-clip img-fluid"
                            src="/svg/shapes/shape-2-lightblue.svg"
                            alt="cirkel vorm"
                        >
                        <img
                            v-if="type == 30"
                            class="image-clip img-fluid"
                            src="/svg/shapes/shape-3-lightblue.svg"
                            alt="cirkel vorm"
                        >
                        <img
                            class="bubble"
                            :class="{'visible' : wasSeen}"
                            src="/svg/shapes/bubble-secondary.svg"
                            alt="bubbel vorm"
                        >
                    </template>
                    <div
                        v-if="logo"
                        class="logo"
                    >
                        <img
                            :data-src="logo"
                            class="lazyload"
                            :alt="title"
                        >

                    </div>
                </div>
                <div
                    v-else
                    class="image text-center w-100"
                >
                    <img
                        class="mw-100 h-auto lazyload"
                        :data-src="image"
                    >
                </div>
            </template>
        </div>
    </div>
</template>

<script>
var slugify = require("slugify");
import Plyr from "plyr";

export default {
    data() {
        return {
            seen: false,
        };
    },

    props: {
        image: {
            type: String,
            required: false,
        },
        video: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: false,
        },
        link: {
            type: String,
            required: false,
        },
        linkText: {
            type: String,
            required: false,
        },
        type: {
            type: Number,
            required: false,
        },
        orientation: {
            type: String,
            required: false,
            default: "left",
        },
        bubble: {
            type: Object,
            required: false,
        },
        logo: {
            type: String,
            required: false,
        },
        large: {
            type: Boolean,
            required: false,
            default: false,
        },
        newTab: {
            type: Boolean,
            required: false,
            default: false,
        },
        mask: {
            type: [Boolean, Number],
            required: false,
            default: false,
        },
    },

    mounted() {
        var self = this;

        var scrollWatcher = function (e) {
            if (self.isInViewport(self.$el)) {
                self.seen = true;
                document.removeEventListener("scroll", scrollWatcher);
            }
        };

        document.removeEventListener("scroll", scrollWatcher);
        document.addEventListener("scroll", scrollWatcher);

        if (this.video != "") new Plyr(this.$refs.player);
    },

    methods: {
        isInViewport(el) {
            var rect = el.getBoundingClientRect();
            var elemTop = rect.top;
            var elemBottom = rect.bottom;

            // Partially visible elements return true:
            var isVisible = elemTop + 120 < window.innerHeight && elemBottom >= 0;
            return isVisible;
        },

        slug(string) {
            return slugify(string.replace(/<\/?[^>]+(>|$)/g, ""), {lower: true});
        },
    },

    computed: {
        bubbleposition() {
            var classes = "";

            var positionX = "right";
            var positionY = "bottom";

            if (this.bubble != undefined) {
                classes += "with-bubble";

                if (this.bubble.positionX.length > 0) {
                    classes += " bubble-" + this.bubble.positionX;
                }

                if (this.bubble.positionY.length > 0) {
                    classes += " bubble-" + this.bubble.positionY;
                }
            } else {
                classes += "no-bubble";
            }

            return classes;
        },

        wasSeen() {
            return this.seen;
        },

        underlinedTitle() {
            var titleHTML = this.title;
            var hashIndex = 0;

            titleHTML = titleHTML.replace(/#/gi, function () {
                if (hashIndex % 2 == 0) {
                    hashIndex++;
                    return '<span class="underline">';
                } else {
                    hashIndex++;
                    return "</span>";
                }
            });

            return titleHTML;
        },

        origin() {
            return window.location.origin;
        },
    },
};
</script>
